import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@americanexpress/dls-react';

let autoComplete;

const loadScript = (url, callback) => {
  if (document.querySelector(`script[src="${url}"]`)) {
    callback(); // If script is already loaded, call the callback immediately
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';

  script.addEventListener('load', () => callback());
  script.src = url;
  document.querySelector('head').appendChild(script);
};

const Search = (props) => {
  const {
    fieldLabel,
    fieldId,
    locale,
    fieldPlaceholder,
    mapClientId,
    cssProperties,
    setFormSubmissionPayload,
    formSubmissionPayload,
  } = props;
  const [query, setQuery] = useState('');
  const autoCompleteRef = useRef(null);

  const handlePlaceSelect = async () => {
    const addressObject = await autoComplete.getPlace();
    const businessName = addressObject.name;
    const formattedAddress = addressObject.formatted_address;
    const addressComponents = addressObject.address_components;
    const phone = addressObject.formatted_phone_number;
    const { website } = addressObject;
    const latLng = {
      lat: addressObject?.geometry?.location?.lat(),
      lng: addressObject?.geometry?.location?.lng(),
    };
    /*
    const address_components = [
      {
        "long_name": "5260",
        "short_name": "5260",
        "types": [
          "street_number"
        ]
      },
    ] */

    // extract street number and street name, city, state, postal code from this
    let city;
    let state;
    let postal;
    let streetName;
    let streetNumber;
    addressComponents.forEach((component) => {
      if (component.types.includes('locality')) {
        city = component.long_name;
      } else if (component.types.includes('administrative_area_level_1')) {
        state = component.short_name;
      } else if (component.types.includes('postal_code')) {
        postal = component.long_name;
      } else if (component.types.includes('route')) {
        streetName = component.long_name;
      } else if (component.types.includes('street_number')) {
        streetNumber = component.long_name;
      }
    });

    const searchResponseObject = {
      formattedAddress,
      fetchedLocation: latLng,
      businessName,
      city,
      state,
      postal,
      phone,
      url: website,
    };
    let streetAddress = '';
    if (streetNumber) streetAddress += streetNumber;
    if (streetName) streetAddress += ` ${streetName}`;
    if (streetAddress) {
      searchResponseObject.streetAddress = streetAddress;
    }
    setFormSubmissionPayload((prev) => ({
      ...prev,
      ...{
        elemId: 'continue',
        searchFlag: 'true',
        fieldId: autoCompleteRef.current.value,
      },
      ...searchResponseObject,
    }));
  };

  const handleScriptLoad = () => {
    autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, {
      types: ['establishment'],
      componentRestrictions: { country: locale },
    });
    autoComplete.addListener('place_changed', handlePlaceSelect);
  };

  const mapURL = `https://maps.googleapis.com/maps/api/js?libraries=places,geometry&sensor=false&client=${mapClientId}`;

  useEffect(() => {
    loadScript(mapURL, handleScriptLoad);
    if (formSubmissionPayload && formSubmissionPayload.fieldId) {
      setQuery(formSubmissionPayload.fieldId);
    }
  }, []);

  return (
    <div className={cssProperties.style}>
      <label htmlFor={fieldId} className={fieldLabel.cssProperties.style}>{fieldLabel.label}</label>
      <Input
        id={fieldId}
        ref={autoCompleteRef}
        onChange={(event) => setQuery(event.target.value)}
        placeholder={fieldPlaceholder}
        value={query}
      />
    </div>
  );
};

Search.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.string,
  locale: PropTypes.string,
  fieldId: PropTypes.string,
  fieldPlaceholder: PropTypes.string,
  mapClientId: PropTypes.string,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
};

export default Search;
